import { render, staticRenderFns } from "./university_studio_press_dynamic.vue?vue&type=template&id=7ef1300e"
import script from "./university_studio_press_dynamic.vue?vue&type=script&lang=js"
export * from "./university_studio_press_dynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementBuilder: require('/home/ubuntu/containers/hermes_eshop/components/core/elementBuilder.vue').default})
